import React, { useState, Fragment } from "react";
import { Button } from "core/components/form-controls";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import SelectSwiper from './SelectSwiper'
import { useAuthModal } from "core/context";

type TAddIngredientByImageSwiperButton = {
  className?: string,
  onOpen?: () => void,
  onClose?: () => void,
  hideIcon?: boolean,
  primary?: boolean,
  size?: string,
  children?: React.ReactNode,
}

const AddIngredientByImageSwiperButton = ({
  className,
  onOpen,
  onClose,
  hideIcon = false,
  primary = false,
  size,
  children,
}: TAddIngredientByImageSwiperButton) => {

  const { openModal, token } = useAuthModal();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const toggleDrawer = () => {
    if (!token) {
      openModal(() => {
        document.getElementById('AddIngredientByImageSwiperButton')?.click()
      });
      return;
    }

    if (!isDrawerOpen) {
      if (["android"].includes((window as any)._APP_PLATFORM.toLowerCase())) {
        (window as any).webViewRequestHasPopupMain('showed');
      }
      onOpen?.();
      setTimeout(() => {
        setIsDrawerOpen((prevState: boolean) => !prevState);
      }, 200)
    } else {
      if (["android"].includes((window as any)._APP_PLATFORM.toLowerCase())) {
        (window as any).webViewRequestHasPopupMain('closed');
      }
      setIsDrawerOpen((prevState: boolean) => !prevState);
      setTimeout(() => {
        onClose?.();
      }, 200)
    }
  };

  return (
    <Fragment>
      <div
        onClick={toggleDrawer}
        id={'AddIngredientByImageSwiperButton'}
      >
        {children ? (
          <div className={className}>
            {children}
          </div>
        ) : (
          <Button
            label={_t('aiChef.add_by_image')}
            classBtn={className}
            icon={!hideIcon ? Icon.RecipeSelectByImage : null}
            primary={primary}
            size={size}
          />
        )}
      </div>
      
      {isDrawerOpen ? <SelectSwiper
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        toggleDrawer={toggleDrawer}
      /> : null}
    </Fragment>
  )
}

export default AddIngredientByImageSwiperButton
